module.exports = __webpack_public_path__ + "img/cat1_white.0da04954.png";